<template>
  <article class="user_view">
    <left-menu/>
    <select-device @cancel="onCancel" :typeSelection="'multiple'" :companies="this.selectedCompany" @select="onSelect" v-if="showModal"/>
    <section class="new_user">
      <div @click="$router.push({ name: 'Coordinators' })" class="back_button">
        <img src="./../../assets/img/icons/back-button.svg">
        <span>atrás</span>
      </div>
      <section class="new_user__form">
        <h1> Crear coordinador </h1>
        <div class="new_user__form--input-sec">
          <div class="form_input">
            <label>Nombre *</label>
            <input v-model="user.name" placeholder="Nombre"/>
          </div>
          <div class="form_input">
            <label>Apellido *</label>
            <input v-model="user.lastName" placeholder="Apellido"/>
          </div>
          <div class="form_input">
            <label>Número de cédula *</label>
            <input v-model="user.cc" type="number" placeholder="Número de cédula"/>
          </div>
          <div class="form_input">
            <label>ID Carné</label>
            <input v-model="user.id"  type="number" placeholder="Id carné"/>
          </div>
          <div class="form_input">
            <label>Correo electrónico *</label>
            <input v-model="user.email" @input="checkMailAcepted" type="text" placeholder="Correo electrónico"/>
          </div>
          <div class="form_input">
            <label>Empresa * <small>{{(user.company).length}} Empresas seleccionadas</small></label>
            <input style="cursor: pointer;" v-model="user.company" @click="showModal = true" placeholder="Seleccionar empresas"/>
          </div> 
         
              
        </div>
        <div style="margin-bottom:10px">
          <h5  class="login__sect-right__form--error">{{errorMessage}}</h5> 
        </div>
         
        <button class="secondary_button" @click.prevent="createCoordinator" :class="{'click':isCreated,'active': isComplete()}" :style="{width: '160px', height:'46px'}">CREAR</button>
      </section>
    </section>
  </article>
</template>

<script>

export default {
  data(){
    return{
      isCreated:false,
      user: {
        name: '',
        lastName: '',
        cc: '',
        id: '',
        email: '',
        company: [],
      },
      showModal: false,
      selectedCompany:[],
      errorMessage:"",
      isInError: false,
    }
  },
  methods:{
      createCoordinator(){
        if(this.user.id.length<=0){
          this.user.id=this.user.cc;
        }
        this.isCreated=true;  
        setTimeout(() => { this.isCreated=false; }, 200);
        const customActions={
          create: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'POST'}                   
        };
        this.resource= this.$resource('coordinators/users',{},customActions);
        this.resource.create({
          "user": {"id_card": this.user.cc, "card_company": this.user.id,"name": this.user.name, "last_name": this.user.lastName},
          email: this.user.email,
          company: this.selectedCompany
        })
        .then(function(data){
          this.errorMessage="";
          this.$router.push({ name: 'Coordinators' });
        }).catch(function(err){
          console.log('Error')
          var errorlog=Object.keys(JSON.parse(err.bodyText).errors)[0];
          if (JSON.parse(err.bodyText).errors[errorlog][0]){
            if(JSON.parse(err.bodyText).errors[errorlog][0]=="has already been taken"){
              this.errorMessage="El número de cédula o el correo electrónico ya se encuentra registrado"             
            }else{
              this.errorMessage="Ha ocurrido un error en la creación, intentelo de nuevo"
            }
          }else{
            this.errorMessage="Ha ocurrido un error en la creación, intentelo de nuevo"
          }
          
          
        });
      },
      isComplete(){
        if(this.user.name!='' && this.user.lastName!='' && this.user.cc!='' && this.user.email!='' && !this.isInError && this.user.company != ''){
          return true;
        }
      },
      onCancel(value){
        this.showModal = value;
      },
      onSelect(value){
        this.user.company = [];
        this.selectedCompany = [];
        value.forEach(element => {
          this.user.company.push(element.name);
          this.selectedCompany.push(element.id);
        });
        this.showModal = false;
        
      },
      checkMailAcepted(){
        if(!this.isMailAcepted){
          this.isInError=true;
        }
        else{
          this.isInError=false
        }
      },
  },
  created(){
      
      
  },
  computed:{
      isMailAcepted(){
        var regex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(this.user.email) ? true : false;
      }
    },
  
}
</script>


// WEBPACK FOOTER //
// src/components/pages/CreateCoordinator.vue